import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { OrderTile } from "../orderTile/orderTile";
import { getCardData, getIcons, getValueFromPath, getUserAnalyticsLobConfig, getAnalyticsUserData, findCurrentWeekCountAndValue } from "../../services/analyticsService";
import { Skeleton } from '@mui/material';
import { getMetaDataConfig } from "../../services/uiConfigService";


export function SfaUserAnalytics() {

  const [chartData, setChartData] = useState<Record<string, any>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [callApi, setCallApi] = useState<boolean>();
  const [configData, setConfigData] = useState<Record<string, any>>([]);
  const [activeUserSecondary, setActiveUserSecondary] = useState<string>("0");
  const [mtdActiveUserSecondary, setMTDActiveUserSecondary] = useState<string>("0");
  const checkFetchFromSaleslens = async () => {
    try {
      const portalConfig: Record<string, any> = await getMetaDataConfig("clientConfig", "portal_configuration");
      for (const key of portalConfig?.domainValues || []) {
        if (key?.name === "fetchFromSaleslens" && key?.value === true) {
          return true;
        }
      }
      return false;
      // return true;
    } catch (error) {
      console.error('Error fetching portal configuration:', error);
      return false;
    }
  }
  const getTodayuserChart = async () => {
    try {
      const configData = getUserAnalyticsLobConfig();
      setConfigData(configData);

      const responseToday: Record<string, any> = await getAnalyticsUserData();
      if (responseToday !== undefined && 'data' in responseToday) {
        setChartData(responseToday?.data);
        setCallApi(false);
      }
      else {
        setCallApi(true);
      }
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    getTodayuserChart();
    const fetchData = async () => {
      try {
        const saleslens = await checkFetchFromSaleslens();
        if(saleslens){
          const responseToday: Record<string, any> = await getAnalyticsUserData();
          const weekly = await findCurrentWeekCountAndValue(responseToday?.data)
          setActiveUserSecondary(weekly)
        }else{
          const responseActiveUserSecondary = await getCardData("/v3/analyticsreport", "numberOfLoggedInDateRange", "Current Week", "portal", "scheduled");
          setActiveUserSecondary(responseActiveUserSecondary);
        }
        const responseMTDActiveUserSecondary = await getCardData("/v3/analyticsreport", "numberOfLoggedInDateRange", "Last Month", "portal", "scheduled");
        setMTDActiveUserSecondary(responseMTDActiveUserSecondary);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    }
    fetchData();
  }, []);

  return (
    <div className="box-container">
      <div className="tile-container">
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {
            (loading || chartData.length === 0 && !callApi) ?
              (<Skeleton variant="rectangular" width={264} height={128} />) :
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                  heading={"ACTIVE USERS"}
                  subHeading={"Today"}
                  footerHeading={"Current Week"}
                  img={getIcons("faMobileScreen")}
                  api={""}
                  api2={""}
                  callApi={false}
                  orderPrimaryValue={getValueFromPath(chartData, "dau.daily.count")}
                  orderSecondaryValue={activeUserSecondary}
                />
              </Grid>
          }
          {
            (loading || chartData.length === 0 && !callApi) ?
              (<Skeleton variant="rectangular" width={264} height={128} />) :
              <Grid item lg={3} sm={6} xs={12}>
                <OrderTile
                  heading={"MTD ACTIVE USERS"}
                  subHeading={"Current Month"}
                  footerHeading={"Last Month"}
                  img={getIcons("faUser")}
                  api={""}
                  api2={""}
                  callApi={false}
                  orderPrimaryValue={getValueFromPath(chartData, "mau.monthly.count")}
                  orderSecondaryValue={mtdActiveUserSecondary}
                  visible={false}
                />
              </Grid>
          }
        </Grid>
      </div>
    </div>
  );
}